
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlayerConfig } from '@/interfaces/player-config.interface';

import LogoOverlay from '@/components/LogoOverlay.vue';
import { statisticService } from '@/services/statistic.service';

@Component({
  components: {
    LogoOverlay,
  },
})
export default class StartTemplate extends Vue {
  @Prop() public playerConfig!: PlayerConfig;
  public isFadingOut: boolean = false;

  private created() {
    /**
     * Analytics "INIT" event should be send when player is initialized in splash screen mode
     * https://earthtv.atlassian.net/browse/WV-108
     */
    if (!this.playerConfig.autoplay) {
      statisticService.ga('SplashScreenLoaded');
    }
  }

  private handleClick() {
    // Start fade-out animation (but don't delay the process)
    this.isFadingOut = true;

    // Emit immediately - transition is visual only
    this.$emit('resume');
  }
}
